import { useState } from "react";
import { Card, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useAuth } from "../../../components/layout/auth";

// Import forms dynamically
import * as Forms from "./forms";

export default function DataGroup({ title, subtitle, formName, mainData, setMainData, verification, children }) {
  const [visible, setVisible] = useState(false);
  const user = useAuth();

  const commonFormProps = { mainData, setMainData, setVisible, visible, title: formName };

  const formComponents = {
    "Información general": Forms.GeneralForm,
    Fechas: Forms.FechasForm,
    Notas: Forms.NotasForm,
    "Información de la Razón social": Forms.PVInfoForm,
    "Domicilio de la Razón social": Forms.PVDomicilioForm,
    "Persona que firma el contrato": Forms.PFInfoForm,
    "Persona que atiende la visita": Forms.PAInfoForm,
    "Persona que solicita la verificación": Forms.PSInfoForm,
    "Clasificación de la verificación": Forms.ClasificacionForm,
    "Valores de la instalación eléctrica": Forms.ValoresForm,
    "Información del Transformador": Forms.TransformadorForm,
    Aranceles: Forms.MontoForm,
    "Desarrollo de la visita": Forms.DesarrolloForm,
    Pruebas: Forms.PruebasForm,
    "Testigo 1": Forms.TestigoForm,
    "Testigo 2": Forms.TestigoForm,
    
    "Tipo de Edificio": Forms.Nom007TipoEdificioForm,
    "DPEA Interior": Forms.Nom007DPEAInteriorForm,
    "DPEA Exterior": Forms.Nom007DPEAExteriorForm,
    "DPEA Estacionamiento": Forms.Nom007DPEAEstacionamientoForm,
    "Vialidad": Forms.Nom013VialidadForm,
    "Iluminación": Forms.Nom013IluminacionForm,
  };

  const specialForms = ["Desarrollo de la visita", "Pruebas", "Testigo 1", "Testigo 2"];

  // // Default condition
  // let disabled = user?.Rol !== "director" && verification?.Status >= 2;

  // // Override condition for special forms
  // if (specialForms.includes(formName)) {
  //   console.log(mainData.Bloqueada);
  //   disabled = mainData?.Bloqueada === 1;
  // }

  const disabled = !specialForms.includes(formName) ? user?.Rol !== "director" && verification?.Status >= 2 : false;

  const SelectedForm = formComponents[formName] || null;

  return (
    <>
      <Card size="small" bordered={false} style={{ height: "100%", boxSizing: "border-box" }}>
        <span className="name-preview">{title}</span>
        <Button
          type="primary"
          icon={<EditOutlined />}
          style={{ float: "right" }}
          size="small"
          onClick={() => setVisible(true)}
          disabled={disabled}
        />
        <br />
        <span className="name-preview-subtitle">{subtitle}</span>
        <div className="data-group">{children}</div>
      </Card>

      {SelectedForm && <SelectedForm {...commonFormProps} />}
    </>
  );
}
